import { sendSignInLinkToEmail, isSignInWithEmailLink, signInWithEmailLink } from "firebase/auth";
import { auth } from "@/lib/firebase";
import { config } from "@/config";

const LINK_EMAIL_KEY = "nexus_link_email";

/**
 * Send a Firebase sign-in link to the given email address.
 * The user will be redirected to /auth/link after clicking the link.
 */
export async function sendLoginLink(email: string): Promise<void> {
  const actionCodeSettings = {
    url: `${window.location.origin}/auth/link`,
    handleCodeInApp: true,
  };
  await sendSignInLinkToEmail(auth, email, actionCodeSettings);
  localStorage.setItem(LINK_EMAIL_KEY, email);
}

/** Check if the current URL is a Firebase sign-in email link */
export function isEmailLink(url: string): boolean {
  return isSignInWithEmailLink(auth, url);
}

/** Retrieve the email stored when the link was sent (may be null if cleared/different device) */
export function getStoredLinkEmail(): string | null {
  return localStorage.getItem(LINK_EMAIL_KEY);
}

/** Clear the stored email after successful sign-in */
export function clearStoredLinkEmail(): void {
  localStorage.removeItem(LINK_EMAIL_KEY);
}

/** Complete Firebase email link sign-in — returns the UserCredential */
export async function completeEmailLinkSignIn(email: string, url: string) {
  const credential = await signInWithEmailLink(auth, email, url);
  clearStoredLinkEmail();
  return credential;
}
